import { Outlet } from "react-router-dom";
import AnalyticsUserSync from "./components/Analytics/AnalyticsUserSync";
import Layout from "./components/Layout/Layout";
import { useAuthStore } from "./store";

function App() {

  //////////////////////////////////////////////////////////////

  const { isLoggedIn } = useAuthStore();

  //////////////////////////////////////////////////////////////

  return (
    <>
      <AnalyticsUserSync />

      {isLoggedIn ? (
        // 로그인된 사용자는 Layout과 함께 Outlet을 렌더링
        <Layout />
      ) : (
        // 로그인되지 않은 사용자는 Layout 없이 Outlet만 렌더링
        <Outlet />
      )}
    </>
  );
}

export default App;
